import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'; // Import any other Firebase services you plan to use

const firebaseConfig = {
  apiKey: "AIzaSyB2wSZm59PDNITIQKsnJMRDEmCAcuqS2LM",
  authDomain: "sharepad-bdf76.firebaseapp.com",
  projectId: "sharepad-bdf76",
  storageBucket: "sharepad-bdf76.appspot.com",
  messagingSenderId: "396043609560",
  appId: "1:396043609560:web:7bfc399c7f6125613e7ead"
};

const firebaseA = firebase.initializeApp(firebaseConfig);


export default firebaseA;